import React from 'react';
import styles from './visualiser.module.css';
export * from "./VisualiserTextBox/index"
export * from "./VisualiserGroup/index"
export * from "./VisualiserImageArea/index"

type VisualiserProps = {
  type: "INSERT" | "GREETINGS_CARD",
  background?: string;
  children?: React.ReactNode;
  isGrouped?: boolean;
  gap?: string;
  subtitle?: string;
}

export const Visualiser = ({
  type,
  background,
  children,
  isGrouped,
  gap,
  subtitle
}: VisualiserProps) => {

  const typeStyle = 
    type === "INSERT" ? styles['visualiser--insert'] :
    type === "GREETINGS_CARD" ? styles['visualiser--greetingsCard'] :
    null;

  const groupedStyle = isGrouped ? styles['visualiser--grouped'] : null;
  
  const visualiser = (
    <div 
      className={`
        ${styles['visualiser']} 
        ${typeStyle ?? ''}
        ${groupedStyle ?? ''}
      `}
      style={{ 
        "--vis-bg": background || "var(--color-white)",
        "--vis-gap": gap
      } as React.CSSProperties} 
    >
      {children ? children : ' '}
    </div>
  )

  return subtitle ? (
    <div className={`${styles['visualiser-subtitle-container']}`}>
      {visualiser}
      <span>
        {subtitle}
      </span>
    </div>
  ) : visualiser;
};
